module.exports = __webpack_public_path__ + "img/tpc-1.17419c70.jpg";